let routes = [
    {
        path: '/',
        name: '经销商管理',
        component: ()=>import('../components/child_router_view'),
        children:[{
            path: '/agent-list',
            name: '经销商列表',
            component: ()=>import('../components/bandu/agent/agent_list'),
        },
        {
            path: '/agent-roles',
            name: '角色管理',
            component: ()=>import('../components/bandu/agent/agent_roles'),
        },
        {
            path: '/agent-admins',
            name: '经销商管理员',
            component: ()=>import('../components/bandu/agent/agent_admins'),
        },
        {
            path: '/agent-regions',
            name: '地域管理',
            component: ()=>import('../components/bandu/agent/agent_regions'),
        },
        {
            path: '/agent-home',
            name: '经销商主页',
            component: ()=>import('../components/bandu/agent/agent_home'),
        },
        {
            path: '/add-agent',
            name: '新建经销商',
            component: ()=>import('../components/bandu/agent/add_agent'),
            hideMenu:true
        },
        {
            path: '/edit-agent',
            name: '编辑经销商',
            component: ()=>import('../components/bandu/agent/add_agent'),
            hideMenu:true
        },
        {
            path: '/agent-detail',
            name: '经销商详情',
            component: ()=>import('../components/bandu/agent/agent_home'),
            hideMenu:true
        }],
        meta: {}
    },
    {
        path: '/',
        name: '伴读课本',
        component: ()=>import('../components/child_router_view'),
        children: [{
            path: '/course-list',
            name: '课本资源',
            meta:{
                type:'2'
            },
            component: ()=>import('../components/bandu/course/course_list')
        },{
            path: '/course-class',
            name: '课本分类',
            component: ()=>import('../components/bandu/course/course_class')
        },{
            path: '/add-course',
            name: '新建书籍',
            component: ()=>import('../components/bandu/course/add_course'),
            hideMenu:true
        },{
            path: '/edit-course',
            name: '编辑书籍',
            component: ()=>import('../components/bandu/course/add_course'),
            hideMenu:true
        },{
            path: '/add-course-menu',
            name: '新建书籍',
            component: ()=>import('../components/bandu/course/add_course_menu'),
            hideMenu:true
        }]
    },{
        path:'/',
        name:'图书馆管理',
        component: ()=>import('../components/child_router_view'),
        children:[{
            path:'/book-list',
            name:'书籍管理',
            meta:{
                type:'2'
            },
            component:()=>import('../components/bandu/book/book_list')
        },{
            path: '/add-book',
            name: '新建书籍',
            component: ()=>import('../components/bandu/book/book_add'),
            hideMenu:true
        },{
            path: '/edit-book',
            name: '编辑书籍',
            component: ()=>import('../components/bandu/book/book_add'),
            hideMenu:true
        },{
            path: '/add-book-library',
            name: '新建书籍',
            component: ()=>import('../components/bandu/book/book_add_library'),
            hideMenu:true
        },{
            path: '/book-class',
            name: '图书分类',
            component: ()=>import('../components/bandu/course/course_class')
        },
        {
            path:'/library-list',
            name:'图书馆列表',
            component:()=>import('../components/bandu/book/library_list')
        },
        {
            path:'/book-borrow-list',
            name:'借阅记录',
            component:()=>import('../components/bandu/book/book_borrow_list')
        },
        {
            path:'/borrow-list',
            name:'借阅管理',
            component:()=>import('../components/bandu/book/borrow_list')
        },
        {
            path:'/library-admin',
            name:'管理员',
            component:()=>import('../components/account/library_account'),
            hideMenu:true
        },
        {
            path:'/add-library',
            name:'新建图书馆',
            component:()=>import('../components/bandu/book/library_add'),
            hideMenu:true
        },
        {
            path:'/edit-library',
            name:'编辑图书馆',
            component:()=>import('../components/bandu/book/library_add'),
            hideMenu:true
        },
        {
            path:'/pld-list',
            name:'漂流点列表',
            component:()=>import('../components/bandu/book/pld_list')
        },
        {
            path:'/add-pld',
            name:'添加漂流点',
            component:()=>import('../components/bandu/book/pld_add'),
            hideMenu:true
        },
        {
            path:'/edit-pld',
            name:'编辑漂流点',
            component:()=>import('../components/bandu/book/pld_add'),
            hideMenu:true
        }]
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/bandu.js